import { BaseTextMergeElement } from "./BaseTextMergeElement";
import { TextMergeConfiguration } from "../TextMergeConfiguration";
import { TextSubstitutionConfiguration } from "../TextSubstitutionConfiguration";
import { StateManager } from "../../Common/StateManager";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../Common/Testing/ITestingContext";

export class SubstitutionTextElement extends BaseTextMergeElement {
    readonly __type: string = "substitution";
    readonly name: string = "Substitution Editor";
    readonly ordinal: number = 10;
    readonly styleElement: boolean = false;

    private _configuration: TextSubstitutionConfiguration = new TextSubstitutionConfiguration();

    get configuration(): TextSubstitutionConfiguration {
        this._configuration.inputData = () => {
            return this.getInputData();
        };
        return this._configuration;
    }

    set configuration(value: TextSubstitutionConfiguration) {
        this._configuration = value;
        StateManager.propertyChanged(this, "configuration");
    }

    canAdd(_config: TextMergeConfiguration): boolean {
        return true;
    }

    output(data: ExecutionData, config: TextMergeConfiguration, testContext: ITestingContext | undefined): string {
        this._configuration.defaultValue = config.defaultValue;
        // do substitution
        return this._configuration.run(data, testContext);
    }

    override getStorageData(): object {
        let d = super.getStorageData();

        Reflect.set(d, "configuration", this._configuration.getStorageData());

        return d;
    }

    override setStorageData(d: object) {
        super.setStorageData(d);
        this._configuration.setStorageData(Reflect.get(d, "configuration"));
    }
}
